import * as actions_stock_parts from 'actions/stock-parts-actions';
import * as actions_settings from 'actions/settings-actions';
import React, { useEffect, useState } from 'react';
import firebase from 'firebase/compat/app';
import { FormBuilder, ValidateForm, ModalAlert, ModalForm } from 'enspire-manager-framework';
import { stock_part_fields, stock_part_form_layout } from './stock-part-form-layout';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { toProperCase } from 'components/common/toolbox';

var _ = require('lodash');

export default function StockPartsForm(props) {

	/* Hooks --------------------------*/

	const history = useHistory();
	const params = useParams();
	const dispatch = useDispatch();
	const stockParts = useSelector((store) => store.stockParts);
	const assetTypes = useSelector((store) => store.settings.settings_asset_types);
	const assetType = assetTypes?.find((assetType) => assetType.id == stockParts.stock_part_selected.assetTypeId);
	const partsCategories = useSelector((store) => store.settings.settings_parts_categories)?.filter((o) => o.assetType == assetTypes.find((assetType) => assetType.id == stockParts.stock_part_selected.assetTypeId)?.id);
	const vendors = useSelector((store) => store.profiles.vendors);
	const [state, setState] = useState({
		search: '',
		populated: false,
		form_error: null,
		stockPart: stock_part_fields(),
		expand: false,
	});

	/* Effects --------------------------*/

	// currently not implemented
	useEffect(() => {
		if (props.filter) setState(prev => ({ ...prev, stockPart: { ...prev.stockPart, categoryIds: [{ value: props.filter, label: toProperCase(partsCategories.find((pc) => pc.id == props.filter).name) }] } }));
	}, [props?.filter]);

	useEffect(() => {
		if (!isNew) populateForm();
	}, []);

	useEffect(() => {
		setState((prevState) => {
			if (prevState.populated == false) return ({ ...prevState, stockPart: { ...prevState.stockPart } });
			return prevState;
		});

		setState(prevState => ({ ...prevState, populated: false }));
	}, [state?.stockPart?.category]);

	/* Handlers --------------------------*/

	const handleChange = (e) => {
		let form_error = _.filter(state.form_error, (o) => { return o.field !== e.target.name; });
		setState({ ...state, form_error, stockPart: { ...state.stockPart, [e.target.name]: e.target.value } });
	};

	const handleMultiSelect = (value, target) => {
		let form_error = _.filter(state.form_error, (o) => { return o.field !== target.name; });
		value = value.map((o) => {
			delete o?.__isNew__;
			o.value = o.value.toLowerCase();
			return o;
		});

		if (value.length > 10) {
			return window.toastr.error('You can only tag up to 10 Categories.', 'Too many Categories!');
		}

		if (target.action == 'create-option') {
			confirmCreate(target, value);
			return;

		} else setState(prevState => ({ ...prevState, form_error, stockPart: { ...prevState.stockPart, [target.name]: value } }));
	};
	const handleUpload = (field, filename) => {
		setState(prevState => ({ ...prevState, stockPart: { ...prevState.stockPart, [field]: filename } }));
	};

	/* Actions --------------------------*/

	const confirmCreate = (target, value) => {
		ModalAlert({
			title: 'Are you sure?',
			text: "This Category will be created and made available for selection to other Stock Parts.",
			icon: 'warning',
			show_cancel: true,
			confirm_color: '#8FBC8B',
			confirm_text: 'Yes, create it!',
			callback_success: () => handleAddCategory(target, value)
		});
	};

	const handleAddCategory = (target, value) => {
		dispatch(actions_settings.saveCategory(params.handle, { name: target.option.value, assetType: assetType.id, deleted: false }, null, "partsCategories", (categoryId) => {
			const changeIndex = value.findIndex((o) => o.value == target.option.value);
			value[changeIndex] = { value: categoryId, label: toProperCase(target.option.value) };
			setState(prevState => ({ ...prevState, stockPart: { ...prevState.stockPart, [target.name]: value } }));
		}));
	};

	const populateForm = async () => {
		let stockPart = {
			...state.stockPart,
			...stockParts.stock_part_selected,
			categoryIds: stockParts.stock_part_selected?.categoryIds?.map((pc) => ({ value: pc, label: toProperCase(partsCategories.find((pc2) => pc2.id == pc)?.name) })),
		};

		if (stockParts.stock_part_selected && !state.populated) {
			setState(prevState => ({ ...prevState, stockPart, populated: true }));
		};

	};

	const confirmDelete = () => {
		ModalAlert({
			title: 'Are you sure?',
			text: "This StockPart will be Archived and not appear in Stock Part search! It can be restored or deleted permanently by visiting the Archive page.",
			icon: 'warning',
			show_cancel: true,
			confirm_color: '#8FBC8B',
			confirm_text: 'Yes, archive it!',
			callback_success: () => deleteStockPart(),
		});
	};

	const deleteStockPart = () => {
		dispatch(actions_stock_parts.saveStockPart(params.handle, { ...state.stockPart, deleted: true }, params.form_id, () => {
			history.replace('/' + params.handle + '/' + params.shop_handle + '/stock_parts/' + params.asset_type_id);
		}));
	};

	const submitForm = (stockPartFormLayout) => {
		var form_error = ValidateForm(state.stockPart, stockPartFormLayout);
		setState(prevState => ({ ...prevState, form_error }));

		if (!form_error.length) {

			var newStockPart = {
				...state.stockPart,
				type: 'stock',
				categoryIds: state.stockPart.categoryIds.map((pc) => pc.value),
				assetTypeId: assetTypes.find((assetType) => assetType.id == props.match.params.asset_type_id).id
			};

			dispatch(actions_stock_parts.saveStockPart(params.handle, newStockPart, params.form_id, (stockPartId) => {
				if (stockPartId != state.stockPart.id) {
					history.replace('/' + params.handle + '/stock_parts/' + params.asset_type_id + '/' + stockPartId + '/form/0/assets');
				} else {
					history.goBack();
				}
			}));
		}
	};


	/* Constants --------------------------*/

	var form_layout = stock_part_form_layout(params.handle, firebase, partsCategories, vendors);
	var isNew = (parseInt(params.form_id)) ? false : true;

	return (

		<ModalForm {...props}
			history={history}
			style={1}
			size={'xl'}
			modal_header={`${(isNew) ? 'New ' : ''}Stock Part for  ${toProperCase(assetType?.value)}`}
			cancel_button_title="Cancel"
			save_button_title={'Save Details'}
			submitFormHandler={() => submitForm(form_layout)}
			delete_button_title={'Archive'}
			delete_button_callback={(isNew) ? null : () => confirmDelete()}
			show_spinner={stockParts?.stock_part_save_pending}
		>
			{state.stockPart &&
				<FormBuilder
					callbacks={{
						text: handleChange,
						select: handleChange,
						dropzone: handleUpload,
						multiselect: handleMultiSelect
					}}
					form_error={state.form_error}
					form={form_layout}
					record={state.stockPart}
				/>
			}
		</ModalForm>
	);
}